import React from 'react'
import { LazyTheWestLivePlayerPage } from './TheWestLivePlayerPage.lazy'
import { createRegisterableComponent } from 'common/routing/page-definition'

export const TheWestLivePlayerPageRegistration = createRegisterableComponent(
    'the-west-live-player-page',
    (_, services) => {
        const shareUrl = services.config.publicUrl + services.location.pathname
        return <LazyTheWestLivePlayerPage shareUrl={shareUrl} onEvent={services.onEvent} />
    }
)
